/* eslint-disable */
import createIcon from '../createIcon';

const IconHomeOutlined = createIcon({
  name: 'icon-home-outlined',
  content: '<path d="M512.956 212.829l318.606 265.08v350.467H194.35V477.909l318.606-265.08m0-82.838L130.629 448.597v446.049h764.654V446.049L512.956 127.442z"/><path d="M544.816 512.319h-63.72v191.163h63.72V512.32z"/>',
  width: 1024,
  height: 1024
});
export default IconHomeOutlined;
